var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import clone from 'clone';
import Component from 'vue-class-component';
import { State } from 'vuex-class';
import { Dependencies } from '~/core/decorator';
import FileUpload from '~/components/common/file-upload.vue';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { ImportExcelConfigService } from '~/services/dataimp-service/import-excel-config.service';
import RelationName from '~/components/template-manage/excel-template/relation-name.vue';
var Name = /** @class */ (function (_super) {
    __extends(Name, _super);
    function Name() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileList = [];
        _this.dataSet = [];
        _this.rowData = {};
        _this.disabledStr = [];
        _this.mapData = [];
        _this.importLoading = false;
        _this.dialog = {
            relationName: false,
        };
        _this.relationData = [];
        _this.relationModel = [];
        _this.excelModel = {
            dataStartCol: 'A',
            dataStartRow: 2,
            importExcelConfigItems: [],
            principalId: '',
            principalName: '',
            templateType: 'IMPORT_CASE',
            titleStartCol: 'A',
            titleStartRow: 1,
            name: '',
        };
        _this.rules = {
            principalId: [
                {
                    required: true,
                    message: '请选择',
                },
            ],
            name: [
                {
                    required: true,
                    message: '请输入模板名称',
                },
            ],
            titleStartRow: [
                {
                    required: true,
                    message: '请输入标题起始行',
                },
                {
                    pattern: /^[0-9]*[1-9][0-9]*$/,
                    message: '行号只能为正整数',
                },
            ],
            titleStartCol: [
                {
                    required: true,
                    message: '请输入标题起始列',
                },
                {
                    pattern: /^[A-Z0-9]+$/,
                    message: '列号只能为大写字母',
                },
            ],
            dataStartRow: [
                {
                    required: true,
                    message: '请输入数据起始行',
                },
                {
                    pattern: /^[1-9]|[1-9]\d+$/,
                    message: '行号只能为大于1的正整数',
                },
            ],
            dataStartCol: [
                {
                    required: true,
                    message: '请输入数据起始列',
                },
            ],
        };
        return _this;
    }
    Name.prototype.modifyDataChange = function (value) {
        if (!value)
            return;
        this.excelModel.id = value.id;
        this.dataSet = value.importExcelConfigItems;
        this.excelModel.dataStartCol = value.dataStartCol;
        this.excelModel.dataStartRow = value.dataStartRow;
        this.excelModel.titleStartCol = value.titleStartCol;
        this.excelModel.titleStartRow = value.titleStartRow;
        this.excelModel.principalId = value.principalId;
        this.excelModel.principalName = value.principalName;
        this.excelModel.name = value.name;
    };
    Name.prototype.close = function () {
        var form = this.$refs['form'];
        form.resetFields();
        var upload = this.$refs['upload_template'];
        upload.reset();
        this.dataSet = [];
    };
    Name.prototype.mounted = function () {
        var _this = this;
        this.importExcelConfigService.getExcelList().subscribe(function (data) {
            _this.mapData = data.caseInfoList.concat(data.contractList).concat(data.personalContactList).concat(data.personalHouseList).concat(data.personalIncomeList).concat(data.personalList).concat(data.carInfoList);
        });
    };
    Name.prototype.resetdataSet = function () {
        this.dataSet = [];
    };
    Name.prototype.relateOpen = function (scope) {
        this.rowData = scope;
        this.disabledStr = scope.store.table.data
            .filter(function (v) {
            return v.relationName !== '';
        })
            .map(function (item) {
            return item.relationName;
        });
        this.dialog.relationName = true;
    };
    Name.prototype.reSetClick = function (scope) {
        this.dataSet[scope.$index]['relationName'] = '';
        this.dataSet[scope.$index]['attribute'] = null;
        this.$set(this.dataSet, scope.$index, this.dataSet[scope.$index]);
    };
    /**
     * 提交
     */
    Name.prototype.commit = function () {
        var _this = this;
        this.relationModel = [];
        this.relationData = [];
        this.mapData.filter(function (m) { return m.flag === 0; }).map(function (n) {
            if (_this.dataSet.filter(function (s) { return s.relationName !== ""; }).find(function (m) { return n.cellName === m.relationName; })) {
                _this.relationModel.push(n);
            }
        });
        this.relationData = this.mapData.filter(function (m) { return m.flag === 0; }).filter(function (item) { return !_this.relationModel.some(function (ele) { return ele.cellName === item.cellName; }); });
        if (this.relationData.length > 0) {
            this.$message.warning("\u8BF7\u914D\u7F6E" + this.relationData[0].cellName);
            return false;
        }
        var form = this.$refs['form'];
        form.validate(function (result) {
            if (!result)
                return;
            _this.excelModel.importExcelConfigItems = clone(_this.dataSet);
            if (_this.excelModel.id) {
                _this.importExcelConfigService
                    .updateExcelExportConfig(_this.excelModel)
                    .subscribe(function (data) {
                    _this.close();
                });
            }
            else {
                _this.importExcelConfigService
                    .createExcelExportConfig(_this.excelModel)
                    .subscribe(function (data) {
                    _this.close();
                });
            }
        });
    };
    /**
     * 上传成功回调
     */
    Name.prototype.onUploadSuccess = function (id, data) {
        var _this = this;
        var headerModel = {
            fileId: data.id,
            sheetTotals: '1',
            titleStartCol: this.excelModel.titleStartCol,
            titleStartRow: this.excelModel.titleStartRow,
        };
        this.importLoading = true;
        this.importExcelConfigService
            .parserTemplateHeader(headerModel)
            .subscribe(function (data) {
            _this.importLoading = false;
            _this.$message.success('Excel导入成功');
            _this.dataSet = data || [];
            var count = 0;
            _this.dataSet.forEach(function (v) {
                if (_this.mapData.filter(function (x) { return x.cellName === v.titleName; }).length > 0)
                    return v.relationName = v.titleName;
                count += 1;
                v.relationName = "";
            });
            _this.dataSet.forEach(function (v) {
                _this.mapData.filter(function (x) {
                    if (x.cellName === v.titleName) {
                        v.propertyType = x.propertyType;
                    }
                });
            });
            _this.dataSet.forEach(function (v) {
                _this.mapData.filter(function (x) {
                    if (x.cellName === v.titleName) {
                        v.attribute = x.cellCode;
                    }
                });
            });
            _this.$nextTick(function () {
                _this.$message("\u7CFB\u7EDF\u81EA\u52A8\u5B8C\u6210" + (_this.dataSet.length - count) + "\u4E2A\u5B57\u6BB5\u7684\u6620\u5C04\uFF0C\u5269\u4F59" + count + "\u4E2A\u5B57\u6BB5\u8BF7\u5728\u64CD\u4F5C\u5217\u70B9\u51FB\u6620\u5C04\u8FDB\u884C\u624B\u52A8\u6620\u5C04\u64CD\u4F5C");
            });
        });
    };
    Name.prototype.save = function (relate, row, index) {
        this.dataSet[index].relationName = relate.cellName;
        this.dataSet[index].attribute = relate.cellCode;
        this.dataSet[index].propertyType = relate.propertyType;
        this.$set(this.dataSet, index, this.dataSet[index]);
    };
    Name.prototype.getPrincipalName = function () {
        var _this = this;
        var principal = this.principalList.content.find(function (v) { return v.id === _this.excelModel.principalId; });
        if (principal) {
            this.excelModel.principalName = principal.name;
        }
    };
    __decorate([
        State
    ], Name.prototype, "principalList", void 0);
    __decorate([
        Dependencies(ImportExcelConfigService)
    ], Name.prototype, "importExcelConfigService", void 0);
    __decorate([
        Prop({})
    ], Name.prototype, "modifyData", void 0);
    __decorate([
        Watch('modifyData', { immediate: true })
    ], Name.prototype, "modifyDataChange", null);
    __decorate([
        Emit('close')
    ], Name.prototype, "close", null);
    Name = __decorate([
        Component({
            components: {
                FileUpload: FileUpload,
                RelationName: RelationName,
            },
        })
    ], Name);
    return Name;
}(Vue));
export default Name;
